import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 4.5H0.5M3.5 0.5V2.5M11.5 0.5V2.51562M1.5 1.5H13.5C14.1472 1.5 14.5 1.85279 14.5 2.5V12.5C14.5 13.1472 14.1472 13.5 13.5 13.5H1.5C0.852791 13.5 0.5 13.1472 0.5 12.5V2.51562C0.5 1.86842 0.852791 1.5 1.5 1.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconCalendar;
